import axios from './request'

const URL = {
  // 银行卡列表
  getBankCardList: '/FINANCEBASEINFO-SERVER/bankCardApp/page.magpie',
  // 绑卡
  bindBankCard: '/FINANCEBASEINFO-SERVER/bankCardApp/bindBankCard.magpie',
  // 银行卡号自动识别银行
  getBankInfo: '/PCUSER-SERVICE/pcuser/getBankInfo.magpie',
  // 解绑银行卡
  unBindBankCard: '/FINANCEBASEINFO-SERVER/bankCardApp/unBindBankCard.magpie',
  // 选择银行卡
  myBankCardList: '/FINANCEBASEINFO-SERVER/bankCardApp/myBankCardList.magpie'
}

// 我的账户
class Bankcard {
  /**
   * 银行卡列表
   * @param {object} params
   */
  getBankCardList (params) {
    const url = URL.getBankCardList
    return axios.post(url, params)
  }
  /**
   * 绑卡
   * @param {object} params
   */
  bindBankCard (params) {
    const url = URL.bindBankCard
    return axios.post(url, params)
  }
  /**
   * 银行卡号自动识别银行
   * @param {object} params
   */
  getBankInfo (params) {
    const url = URL.getBankInfo
    return axios.post(url, params)
  }
  /**
   * 解绑银行卡
   * @param {object} params
   */
  unBindBankCard (params) {
    const url = URL.unBindBankCard
    return axios.post(url, params)
  }
  /**
   * 选择银行卡
   * @param {object} params
   */
  myBankCardList (params) {
    const url = URL.myBankCardList
    return axios.post(url, params)
  }
}

export default new Bankcard()
